import { render, staticRenderFns } from "./TuyaSetting.vue?vue&type=template&id=c3b6f0d4&scoped=true"
import script from "./TuyaSetting.vue?vue&type=script&lang=js"
export * from "./TuyaSetting.vue?vue&type=script&lang=js"
import style0 from "./TuyaSetting.vue?vue&type=style&index=0&id=c3b6f0d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b6f0d4",
  null
  
)

export default component.exports